export enum SystemRole {
    All = 'all',
    Developer = 'Developer',
    SystemAdmin = 'SystemAdmin',
    SIPAdmin = 'SIPAdmin',
    StandardUser = 'StandardUser',
    Principal = 'Principal',
    AssistantPrincipal = 'AssistantPrincipal',
    ContentAreaAdmin = 'ContentAreaAdmin',
    Regional = 'Regional',
}
